var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100p flex"},[_c('v-input',{attrs:{"type":"hidden"}}),_vm._v(" "),_c('div',{staticClass:"w-100p h-300",attrs:{"id":"map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }